import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatTableDataSource } from '@angular/material/table';
import { columnsModel } from 'src/app/models/customer.model';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { MatDialog } from '@angular/material/dialog';
import { DeleteBatchAlertComponent } from '../common/delete-batch-alert/delete-batch-alert.component';
import { ViewParticipantsComponent } from '../common/view-participants/view-participants.component';


// Need to be removed once feature work done for the same.
//Current Batch Alert Table
export interface CurrentBatch {
  batchId: number;
  created: string;
  createdBy: string;
  start: string;
  end: string;
  appliedTo: number;
  title: string;
  description: string;
  fileName: string;
}
//Delete Batch Alert Table
export interface DeleteBatch {
  batchId: number;
  deleted: string;
  deletedBy: string;
  created: string;
  createdBy: string;
  start: string;
  end: string;
  appliedTo: number;
  title: string;
  description: string;
}


const ELEMENT_DATA: CurrentBatch[] = [
  { batchId: 123456789, created: 'Jan-01-1901', createdBy: 'Michaelangelo A', start: 'Jan-02-1901', end: 'Jan-03-1901', appliedTo: 12345, title: 'Batch Alert 1', description: 'Description 1', fileName: 'C:\Users\Public\Downloads' },
  { batchId: 768456398, created: 'May-02-2024', createdBy: 'Peterson-001', start: 'May-03-2024', end: 'May-03-2024', appliedTo: 75647, title: 'Batch Alert 2', description: 'Description 2', fileName: 'C:\Users\Public\Downloads' },
  { batchId: 264956730, created: 'Feb-12-2024', createdBy: 'Al Borland', start: 'Feb-12-2024', end: 'Feb-13-2024', appliedTo: 28375, title: 'Batch Alert 3', description: 'Description 3', fileName: 'C:\Users\Public\Downloads' },
  { batchId: 264875643, created: 'Jun-14-2023', createdBy: 'John Doe', start: 'Jun-15-2023', end: 'Jun-16-2023', appliedTo: 12345, title: 'Batch Alert 4', description: 'Description 4', fileName: 'C:\Users\Public\Downloads' },
  { batchId: 938475630, created: 'Apr-01-2024', createdBy: 'Al Borland', start: 'Apr-02-2024', end: 'Apr-03-2024', appliedTo: 93387, title: 'Batch Alert 5', description: 'Description 5', fileName: 'C:\Users\Public\Downloads' },
  { batchId: 209385746, created: 'May-02-2024', createdBy: 'Michaelangelo A', start: 'May-03-2024', end: 'May-03-2024', appliedTo: 56373, title: 'Batch Alert 6', description: 'Description 6', fileName: 'C:\Users\Public\Downloads' },
  { batchId: 277756465, created: 'May-02-2024', createdBy: 'John Doe', start: 'May-02-2024', end: 'May-03-2024', appliedTo: 12345, title: 'Batch Alert 7', description: 'Description 7', fileName: 'C:\Users\Public\Downloads' },
  { batchId: 294384475, created: 'May-10-2024', createdBy: 'Michaelangelo A', start: 'May-11-2024', end: 'May-11-2024', appliedTo: 277465, title: 'Batch Alert 8', description: 'Description 8', fileName: 'C:\Users\Public\Downloads' },

];
const ELEMENT_DATA1: DeleteBatch[] = [
  { batchId: 123456789, deleted: 'Jan-01-1901', deletedBy: 'Michaelangelo A', created: 'Jan-01-1901', createdBy: 'Michaelangelo A', start: 'Jan-02-1901', end: 'Jan-03-1901', appliedTo: 84776, title: 'Batch Alert 1', description: 'Description 1' },
  { batchId: 768456398, deleted: 'May-02-2024', deletedBy: 'Peterson-001', created: 'May-01-2024', createdBy: 'Peterson-001', start: 'May-03-2024', end: 'May-03-2024', appliedTo: 12345, title: 'Batch Alert 2', description: 'Description 2' },
  { batchId: 264956730, deleted: 'Feb-12-2024', deletedBy: 'Al Borland', created: 'Feb-11-2024', createdBy: 'Al Borland', start: 'Feb-12-2024', end: 'Feb-13-2024', appliedTo: 46483, title: 'Batch Alert 3', description: 'Description 3' },
  { batchId: 264875643, deleted: 'Jun-14-2023', deletedBy: 'John Doe', created: 'Jun-13-2023', createdBy: 'Al Borland', start: 'Jun-15-2023', end: 'Jun-16-2023', appliedTo: 54759, title: 'Batch Alert 4', description: 'Description 4' },
  { batchId: 938475630, deleted: 'Apr-01-2024', deletedBy: 'Al Borland', created: 'Apr-01-2024', createdBy: 'Al Borland', start: 'Apr-02-2024', end: 'Apr-03-2024', appliedTo: 12345, title: 'Batch Alert 5', description: 'Description 5' },
  { batchId: 209385746, deleted: 'May-02-2024', deletedBy: 'Michaelangelo A', created: 'May-02-2024', createdBy: 'Michaelangelo A', start: 'May-03-2024', end: 'May-04-2024', appliedTo: 22746, title: 'Batch Alert 6', description: 'Description 6' },
  { batchId: 277756465, deleted: 'May-02-2024', deletedBy: 'John Doe', created: 'May-01-2024', createdBy: 'John Doe', start: 'May-01-2024', end: 'May-02-2024', appliedTo: 50095, title: 'Batch Alert 7', description: 'Description 7' },
  { batchId: 294384475, deleted: 'May-10-2024', deletedBy: 'Michaelangelo A', created: 'May-09-2024', createdBy: 'Michaelangelo A', start: 'May-11-2024', end: 'May-12-2024', appliedTo: 74656, title: 'Batch Alert 8', description: 'Description 8' },

];

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit {
  currentBatchTable: boolean = true;
  archivedBatchTable: boolean = false;
  deletedBatchTable: boolean = false;
  createBatchTable: boolean = false;
  showBatchTable:boolean = true;
  customerSearchForm: FormGroup = new FormGroup({});
  customerAccForm: FormGroup = new FormGroup({});
  @ViewChild('fileInput')
  fileInput;
  fileText:any ="";
  public dataSource: any = new MatTableDataSource<CurrentBatch>(ELEMENT_DATA);
  public dataSource1: any = new MatTableDataSource<DeleteBatch>(ELEMENT_DATA1);
  totalRecords: number = 8;
  public currentColumns: columnsModel[] = [
    { field: 'batchId', header: 'Batch ID', width: 3 },
    { field: 'created', header: 'Created', width: 4 },
    { field: 'createdBy', header: 'Created By', width: 6 },
    { field: 'start', header: 'Start', width: 4 },
    { field: 'end', header: 'End', width: 4 },
    { field: 'appliedTo', header: 'Applied To', width: 1 },
    { field: 'title', header: 'Title', width: 5 },
    { field: 'description', header: 'Description', width: 6 },
    { field: 'fileName', header: 'File Name', width: 12 }
  ];

  public deleteColumns: columnsModel[] = [
    { field: 'batchId', header: 'Batch ID', width: 3 },
    { field: 'deleted', header: 'Deleted', width: 4 },
    { field: 'deletedBy', header: 'Deleted By', width: 6 },
    { field: 'created', header: 'Created', width: 4 },
    { field: 'createdBy', header: 'Created By', width: 6 },
    { field: 'start', header: 'Start', width: 4 },
    { field: 'end', header: 'End', width: 4 },
    { field: 'appliedTo', header: 'Applied To', width: 1 },
    { field: 'title', header: 'Title', width: 6 },
    { field: 'description', header: 'Description', width: 6 }
  ];
  constructor(
    public dialog: MatDialog,
    public rootService: RootScopeService,
    public customerService: CustBusService,
  ) {
  }

  ngOnInit(): void {
  }

  openCurrent(){
    this.showBatchTable=true;
    this.currentBatchTable = true;
    this.archivedBatchTable = false;
    this.deletedBatchTable = false;
    this.createBatchTable = false;
  }

  openArchived(){
    this.showBatchTable=true;
    this.archivedBatchTable = true;
    this.currentBatchTable = false;
    this.deletedBatchTable = false;
    this.createBatchTable = false;
  }

  openDeleted(){
    this.showBatchTable=true;
    this.archivedBatchTable = false;
    this.currentBatchTable = false;
    this.deletedBatchTable = true;
    this.createBatchTable = false;
  }

  openCreate(){
    this.archivedBatchTable = false;
    this.currentBatchTable = false;
    this.deletedBatchTable = false;
    this.createBatchTable = true;
    this.showBatchTable=false;
  }


 

  
  /* istanbul ignore next */
  deleteAlertModal() {
    this.dialog.open(DeleteBatchAlertComponent, {
      panelClass: 'delete-batch-alert',
      backdropClass: 'custom-overlay',
      id: 'deleteBatch'
    });   
  }

  /* istanbul ignore next */
  viewParticipantModal(){
    this.dialog.open(ViewParticipantsComponent, {
      panelClass: 'view-participants',
      backdropClass: 'custom-overlay',
      id: 'viewParticipants'
    });   
  }


  /* istanbul ignore next */
  rowSelection(data) {
  }

  openFile(): void {
    this.fileInput.nativeElement.click();
  }
  
  handle(e){
    console.log('Change input file :-' + e.srcElement.files[0].name);
    let fileName = e.srcElement.files[0].name;
    if(fileName){{
      this.fileText = fileName;
    }
    }
  }

  openFilter() {
    this.rootService.openAdminFilterDialog = true;
  }
}
